import Vue from "vue";
import Router from "vue-router";
import DashboardLayout from "@/layout/DashboardLayout";
import theme from "@/config/POPTheme";
import {
    getRole,
    getRoleAuth0
} from "@/plugins/role"

Vue.use(Router);

const [PATH_DROPOFF, PATH_WALLET] = [
    "./views/Report/Dropoff/",
    "./views/Wallet/",
];


let router = new Router({
    mode: 'hash',
    linkExactActiveClass: "active",
    routes: [
        {
            path: '*',
            name: 'Not Found',
            component: () =>
                import("./views/ERROR/404notfound.vue"),
            meta: {
                guest: true
            }
        },
        {
            path: '/location/timeout',
            name: 'timeout',
            component: () =>
                import("./views/ERROR/timeout.vue"),
            meta: {
                lineAuth: true
            }
        },
        {
            path: "/line/manage/sender",
            name: "managesender",
            component: () =>
                import("./views/Line/manageSender.vue"),
            meta: {
                lineAuth: true
            }
        },
        {
            path: "/line/book/sender",
            name: "booksender",
            component: () =>
                import("./views/Line/BookAllSender.vue"),
            meta: {
                lineAuth: true,
            }
        },
        {
            path: "/line/show/senders",
            component: () =>
                import("./views/Line/LineSender.vue"),
            meta: {
                lineAuth: true
            }
        },
        {
            path: "/line/payment/amount",
            name: "paymentamount",
            component: () =>
                import("./views/Line/PaymentAmount"),
            meta: {
                lineAuth: true
            }
        },
        {
            path: '/line/download/qrcode',
            name: 'DownLoadQRCode',
            component: () =>
                import("./views/Line/downloadQRCode.vue"),
            meta: {
                lineAuth: true
            }
        },
        {
            path: '/line/cancel/order',
            name: 'CancelOrder',
            component: () =>
                import("./views/Line/canceltheItem.vue"),
            meta: {
                lineAuth: true
            }
        },
        {
            path: '/line/edit/consign',
            name: 'editConsign',
            component: () =>
                import("./views/Line/consignAddress.vue"),
            meta: {
                lineAuth: true
            }
        },
        {
            path: '/line/registerpage',
            name: 'LineRegisterPage',
            component: () =>
                import("./views/Line/FillupRegister.vue"),
            meta: {
                lineAuth: true
            }
        },
        {
            path: "/line/action/register",
            name: "registerUsedLine",
            component: () =>
                import("./views/Line/registerUsedLine.vue"),
            meta: {
                lineAuth: true,
            },
        },
        {
            path: "/line",
            name: "lineRedirect",
            component: () =>
                import("./views/Line/lineinittest.vue"),
            meta: {
                guest: true,
            }
        },
        {
            path: '/line/receipt',
            name: 'lineReceipt',
            component: () =>
                import("./views/ReceiptForLine.vue"),
            meta: {
                lineAuth: true
            }
        },
        {
            path: "/order/cancelfeedback",
            name: "cancelorder",
            component: () =>
                import("./views/LineLiff/CancelOrder.vue"),
            meta: {
                guest: true,
            },
        },
        {
            path: "/login",
            name: "login",
            component: () =>
                import("./views/Login.vue"),
            meta: {
                guest: true,
            },
        },
        {
            path: "/login/admin",
            name: "adminlogin",
            component: () =>
                import("./views/Login.vue"),
            meta: {
                guest: true,
            },
        },
        {
            path: "/callback",
            name: "callback",
            component: () =>
                import("./views/Callback.vue"),
            meta: {
                guest: true,
            },
        },
        {
            path: "/lead-sale",
            name: "lead-sale",
            component: () =>
                import("./views/LeadSale.vue"),
            meta: {
                guest: true,
            },
        },
        {
            path: "/pos",
            name: "pos",
            component: () =>
                import("./views/Pos/index.vue"),
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: "/logout",
            name: "logout",
            component: () =>
                import("./views/logout.vue"),
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: "/improve",
            name: "improve",
            component: () =>
                import(
                    "./views/ImproveSystem.vue"
                    ),
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: "/label/inter",
            name: "testtestestlabelinterja",
            component: () =>
                import(
                    "./views/LabelInter.vue"
                    ),
            meta: {
                guest: true
            }
        },
        {
            path: "/label/:labelId/:size",
            name: "label",
            component: () =>
                import("./views/LabelHtml.vue"),
            meta: {
                requiresAuth: false,
            },
            children: [
                {
                    path: "/label/inter/:orderId/:type",
                    name: "labeldropoffinter",
                    component: () =>
                        import(
                            "./views/LabelHtml.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/label/:labelId/:size/:type",
                    name: "labeldropoffshippop",
                    component: () =>
                        import(
                            "./views/LabelHtml.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/label/:type/:orderId/:detailId/:label",
                    name: "customlabel",
                    component: () =>
                        import(
                            "./views/LabelHtml.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
            ],
        },
        {
            path: "/receipt/:receiptId",
            name: "receipt",
            component: () =>
                import("./views/Receipt.vue"),
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: "/delivery/:deliveryId",
            name: "delivery",
            component: () =>
                import("./views/Delivery.vue"),
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: "/report",
            name: "report",
            redirect: "/",
            component: DashboardLayout,
            children: [
                {
                    path: "dropoff",
                    name: "dropoff",
                    component: () => import(PATH_DROPOFF + "Orders.vue"),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "wallet/shops",
                    name: "walletshops",
                    component: () =>
                        import(PATH_WALLET + "SuperAdmin/ReportBrance.vue"),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "invoice",
                    name: "invoice",
                    component: () => {
                        if (theme.menuLayout.reportInvoice) {
                            return import(
                                "./views/Report/Invoice/ReportInvoice.vue"
                                );
                        }
                    },
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "receipt",
                    name: "receipt",
                    component: () => {
                        if (theme.menuLayout.reportReceipt) {
                            return import("./views/Report/Receipt/ReportReceipt.vue")
                        }
                    },
                    meta: {
                        requiresAuth: false,
                    }
                }
            ],
        },
        {
            path: "/",
            redirect: "dashboard",
            component: DashboardLayout,
            children: [
                {
                    path: "dashboard",
                    name: "dashboard",
                    component: () =>
                        import(
                            "./views/Dashboard.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "cancelorders/:orderId",
                    name: "cancelorders",
                    component: () =>
                        import(
                            "./views/CancelOrders.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "dashboardshippop",
                    name: "dashboardshippop",
                    component: () =>
                        import(
                            "./views/Dashboardshippop.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "product",
                    name: "categoryproduct",
                    component: () =>
                        import(
                            "./views/Product_V2.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "product/:categoryId",
                    name: "product",
                    component: () =>
                        import(
                            "./views/Product_V2.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "categoryservice",
                    name: "categoryservice",
                    component: () =>
                        import(
                            "./views/Service.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "service/:categoryId",
                    name: "service",
                    component: () =>
                        import(
                            "./views/Service.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "profile",
                    name: "profile",
                    component: () =>
                        import(
                            "./views/UserProfile.vue"
                            ),
                },
                {
                    path: "usersmanage",
                    name: "usersmanage",
                    component: () =>
                        import(
                            "./views/UsersManage.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/transports",
                    name: "transportmanage",
                    component: () =>
                        import(
                            "./views/TransportManage.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/transports/inter",
                    name: "transportintermanage",
                    component: () =>
                        import(
                            "./views/Inter/TransportInterManage.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/transport/inter",
                    name: "transportinter",
                    component: () =>
                        import(
                            "./views/Inter/TransportInterEdit.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                    children: [
                        {
                            path: "/transport/inter/edit/:Id",
                            name: "transportinteredit",
                            component: () =>
                                import(
                                    "./views/Inter/TransportInterEdit.vue"
                                    ),
                            meta: {
                                requiresAuth: false,
                            },
                        },
                    ],
                },
                {
                    path: "/transport",
                    name: "transport",
                    component: () =>
                        import(
                            "./views/TransportEdit.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                    children: [
                        {
                            path: "/transport/:Id",
                            name: "transportedit",
                            component: () =>
                                import(
                                    "./views/TransportEdit.vue"
                                    ),
                            meta: {
                                requiresAuth: false,
                            },
                        },
                    ],
                },
                {
                    path: "/brancemanage",
                    name: "brancemanage",
                    component: () =>
                        import(
                            "./views/Brance.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/branceedit/:Id",
                    name: "branceedit",
                    component: () =>
                        import(
                            "./views/BranceEdit.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/agent/:Id",
                    name: "agent",
                    component: () =>
                        import(
                            "./views/Agent.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/agentmanage",
                    name: "agentmanage",
                    component: () =>
                        import(
                            "./views/AgentManage.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/branceedit/",
                    name: "adminbranceedit",
                    component: () =>
                        import(
                            "./views/BranceEdit.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/reporttransport",
                    name: "reporttransport",
                    component: () =>
                        import(
                            "./views/Report/ReportTransport.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/reportbrance",
                    name: "reportbrance",
                    component: () =>
                        import(
                            "./views/Report/ReportBrance.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/reportcod",
                    name: "reportcod",
                    component: () =>
                        import(
                            "./views/Report/ReportCod.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/reportcod/:Id",
                    name: "reportcodmember",
                    component: () =>
                        import(
                            "./views/Report/ReportCod.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/reportpos",
                    name: "reportpos",
                    component: () =>
                        import(
                            "./views/Report/ReportPos.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/reportproduct",
                    name: "reportproduct",
                    component: () =>
                        import(
                            "./views/Report/ReportProduct.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/reportdropoffshippop",
                    name: "reportdropoffshippop",
                    component: () =>
                        import(
                            "./views/Report/ReportDropoffShippop.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/reportshippop",
                    name: "reportshippop",
                    component: () =>
                        import(
                            "./views/Report/ReportShippop.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/exportdelivery",
                    name: "exportdelivery",
                    component: () =>
                        import(
                            "./views/ExportDelivery.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/reportdelivery",
                    name: "reportdelivery",
                    component: () =>
                        import(
                            "./views/Report/ReportDelivery.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/reportparcel",
                    name: "reportparcel",
                    component: () =>
                        import(
                            "./views/Report/ReportParcel.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/registermember",
                    name: "registermember",
                    component: () =>
                        import(
                            "./views/RegisterMember.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/registermember/:email",
                    name: "registermemberbyemail",
                    component: () =>
                        import(
                            "./views/RegisterMember.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/confirmCommissionSPAdmin",
                    name: "confirmCommissionSPAdmin",
                    component: () =>
                        import(
                            "./views/ReportVerifyShop/ConfirmShopsCommissionSPAdmin.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/resgisterCommission",
                    name: "resgisterCommission",
                    component: () =>
                        import(
                            "./views/RegisterCommission.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/verify/:Id",
                    name: "dataverrify",
                    component: () =>
                        import(
                            "./views/ShowDataVerrify.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/verify/shippop/:UserId",
                    name: "verrifyshippop",
                    component: () =>
                        import(
                            "./views/ShowDataVerrify.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/usershop",
                    name: "usershop",
                    component: () =>
                        import(
                            "./views/UserShop.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/membershop",
                    name: "membershop",
                    component: () =>
                        import(
                            "./views/Member.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/flefixparcel",
                    name: "flefixparcel",
                    component: () =>
                        import(
                            "./views/FlashFixParcel.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/manage/driver",
                    name: "managedriver",
                    component: () =>
                        import(
                            "./views/ManageDriver.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/shop/commission",
                    name: "shopcommission",
                    component: () =>
                        import(
                            "./views/ShopCommission.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/superadmin/commission",
                    name: "superadmincommission",
                    component: () =>
                        import(
                            "./views/SuperAdminCommission.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/membercod",
                    name: "membercod",
                    component: () =>
                        import(
                            "./views/MemberCod.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/memberedit/:Id",
                    name: "memberedit",
                    component: () =>
                        import(
                            "./views/MemberCodEdit.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/transfer/statement/cod",
                    name: "statementTransfer",
                    component: () =>
                        import(
                            "./views/Report/Cod/TransferCodStatement.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/createbill/",
                    name: "createbill",
                    component: () =>
                        import(
                            "./views/Report/Cod/CreateBill.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/historycancel",
                    name: "historycancel",
                    component: () =>
                        import(
                            "./views/HistoryCancel.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/changelog",
                    name: "changelog",
                    component: () =>
                        import(
                            "./views/ChangeLog.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/topupcredit",
                    name: "topupcredit",
                    component: () =>
                        import(
                            "./views/Wallet/Admin/TopUpCredit.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/history/topupwallet",
                    name: "historytopupwallet",
                    component: () =>
                        import(
                            "./views/Wallet/Admin/HistoryTopUpWallet.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/history/usagewallet",
                    name: "historyusagewallet",
                    component: () =>
                        import(
                            "./views/Wallet/Admin/HistoryUsageWallet.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/history/usagewallet/superadmin",
                    name: "historyusagewalletsuperadmin",
                    component: () =>
                        import(
                            "./views/Wallet/SuperAdmin/HistoryUsageWallet.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/withdraw/credit",
                    name: "withdrawcredit",
                    component: () =>
                        import(
                            "./views/Wallet/SuperAdmin/WithDrawCredit.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/topupcredit/shop",
                    name: "topupcredittoshop",
                    component: () =>
                        import(
                            "./views/Wallet/SuperAdmin/TopUpCreditToShop.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/history/topupcredit/superadmin",
                    name: "historytopupwallettoshop",
                    component: () =>
                        import(
                            "./views/Wallet/SuperAdmin/HistoryTopUpWalletToShop.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/creditbalance/shop",
                    name: "creditbalanceshop",
                    component: () =>
                        import(
                            "./views/Wallet/SuperAdmin/CreditBalanceShop.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/reportoverweight",
                    name: "reportoverweight",
                    component: () =>
                        import(
                            "./views/Wallet/SuperAdmin/ReportOverWeight.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/history/topbalance",
                    name: "historytopbalance",
                    component: () =>
                        import(
                            "./views/Wallet/Shippop/HistoryTopBalance.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/history/topup",
                    name: "historytopup",
                    component: () =>
                        import(
                            "./views/Wallet/Shippop/HistoryTopUpWallet.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/tracking",
                    name: "tracking",
                    component: () =>
                        import(
                            "./views/Tracking.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/salesRecords",
                    name: "salesRecords",
                    component: () =>
                        import("./views/SalesRecords/index.vue"),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/customStandardPrice",
                    name: "customStandardPrice",
                    component: () =>
                        import("./views/CustomStandardPrice/index.vue"),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/orderList",
                    name: "orderList",
                    component: () =>
                        import(
                            "./views/newPages/OrderList.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/productManagement",
                    name: "productManagement",
                    component: () =>
                        import(
                            "./views/newPages/ProductManagement/index.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    }
                },
                {
                   path: '/commodityOrders',
                   name: 'commodityOrders',
                     component: () =>
                          import(
                            "./views/newPages/ProductManagement/commodityOrders.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    }
                },
                {
                    path: "/DropOffHome",
                    name: "DropOffHome",
                    component: () =>
                        import(
                            "./views/newPages/DropOff/index.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    }
                },
                {
                    path: "/DropOffPackageList",
                    name: "DropOffPackageList",
                    component: () =>
                        import(
                            "./views/newPages/DropOff/dropOffPackageList.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    }
                },
                {
                    path: '/DropOffBill',
                    name: 'DropOffBill',
                    component: () =>
                        import(
                            "./views/newPages/DropOff/dropOffBill.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    }
                },
                {
                    path: '/DropOffTimeout',
                    name: 'DropOffTimeout',
                    component: () =>
                        import(
                            "./views/newPages/DropOff/dropOffTimeout.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    }
                },
                {
                    path: '/certification',
                    name: 'certification',
                    component: () =>
                        import(
                            "./views/newPages/Certification/index.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    }
                },
                {
                    path: "/InsuranceService",
                    name: "InsuranceService",
                    component: () =>
                        import(
                            "./views/newPages/TQM/index.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    }
                },
                {
                    path: "/addressManagement",
                    name: "addressManagement",
                    component: () =>
                        import(
                            "./views/newPages/AddressManagement/index.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    }
                },
                {
                    path: "/monthReceipt",
                    name: "monthReceipt",
                    component: () =>
                        import(
                            "./views/newPages/MonthReceipt/index.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    }
                },
                {
                    path: "COD",
                    name: "COD",
                    component: () =>
                        import(
                            "./views/newPages/COD/index.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    }
                },
                {
                    path: 'codList',
                    name: 'codList',
                    component: () =>
                        import(
                            "./views/newPages/COD/codList.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    }
                },
                {
                    path: 'cashRecords',
                    name: 'cashRecords',
                    component: () =>
                        import(
                            "./views/newPages/CashRecords/index.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    }
                },
                {
                    path: 'cashRecordsDetail',
                    name: 'cashRecordsDetail',
                    component: () =>
                        import(
                            "./views/newPages/CashRecords/cashRecordsDetail.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    }
                },
                {
                    path: '/receiptDetailList',
                    name: 'receiptDetailList',
                    component: () =>
                        import(
                            "./views/newPages/MonthReceipt/receiptDetailList.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    }
                },
                {
                    path: '/notification',
                    name: 'Notification',
                    component: () =>
                        import(
                            "./views/newPages/Notification/index.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    }
                },
                {
                    path: '/SubAccount',
                    name: 'SubAccount',
                    component: () =>
                        import(
                            "./views/newPages/SubAccount.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    }
                },
                {
                    path: '/StoreManagement',
                    name: 'StoreManagement',
                    component: () =>
                        import(
                            "./views/newPages/StoreManagement/index.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    }
                },
                {
                    path: "/ratemanagement/:Id",
                    name: "ratemanagement",
                    component: () =>
                        import(
                            "./views/RateManagement.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/inter/ratemanagement/:Id",
                    name: "interRatemanagement",
                    component: () =>
                        import(
                            "./views/InterRateManagement.vue"
                            ),
                    meta: {
                        requiresAuth: false,

                    },
                },
                {
                    path: "/waiveinvoice",
                    name: "waiveinvoice",
                    component: () =>
                        import(
                            "./views/WaiveInvoice.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "/fakecustomer",
                    name: "fakecustomer",
                    component: () =>
                        import(
                            "./views/FakeCustomer.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    path: "manage/cod",
                    name: "managecod",
                    component: () => import("./views/Cod/ManageCod.vue"),
                    meta: {
                        requiresAuth: false,
                    }
                },
                {
                    path: "/setting/line",
                    name: "settingline",
                    component: () =>
                        import(
                            "./views/Line/SettingLine.vue"
                            ),
                    meta: {
                        requiresAuth: false,
                    },
                },
            ],
        },
        {
            path: "/callback/wallet-verification",
            name: "callbackwalletverification",
            component: () => import("./views/Callback/WalletVerification.vue"),
            meta: {
                requiresAuth: false,
            }
        }
    ],
});

export default router;
